import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router";
import {
  styleCustomerColor,
  styleTopSecBackgroundColor,
  styleTopSecColor,
} from "./helper";
import moment from "moment";
import { useEffect, useState } from "react";
import {
  checkStatuseWhatsappAppoinmentStatusAction,
  getWhatsappAppointmentActions,
} from "../../../redux/actions/AppoinmentAction";
import PaginatedItems from "../../../common/Pagination";
import WhatsappConfirmationPopup from "./WhatsappConfirmationPopup";
import Modal from "react-modal";
import { WhatsappUploadReportPopup } from "./WhatsappUploadReportPopup";
import { getSnackbarSuccess } from "../../../Utils/helper";

const WhatsappAppointmentActions = () => {
  const params = useParams();
  const dispatch = useDispatch();
  const [cardIndex, setCardIndex] = useState(null);
  const [isShowMoreAddress, setIsShowMoreAddress] = useState(false);
  const [isShowMore, setIsShowMore] = useState(false);
  const [isConfirmationPopup, setIsConfirmationPopup] = useState(null);
  const [isUploadReportPopup, setIsUploadReportPopup] = useState(null);

  const AppoinmentReducer = useSelector((state) => state?.AppoinmentReducer);
  const globalReducer = useSelector((state) => state?.globalReducer);

  useEffect(() => {
    dispatch(
      getWhatsappAppointmentActions(
        {
          page: globalReducer?.getCurrentPage,
          rows: 10,
        },
        params
      )
    );
  }, [globalReducer?.getCurrentPage]);

  const checkStatusUpdateHandler = async (ele, DCConfirmationFlag) => {
    const temp = {
      appointmentId: ele?.appointmentId,
      dcConfirmationFlag: DCConfirmationFlag,
      appointmentDate: ele?.appointmentDateTime,
      timeSlot: moment(ele?.appointmentDateTime).format("YYYY-MM-DD hh:mm A"),
      appointmentStatusId: ele?.appointmentstatusid,
      validate: true,
      remarkId: 0,
      valueType: ele?.valueType,
    };
    const resp = dispatch(
      checkStatuseWhatsappAppoinmentStatusAction(temp, params)
    );
    resp.then(async (res) => {
      if (res?.data?.status) {
        if (DCConfirmationFlag === "S") {
          setIsConfirmationPopup({
            isOpen: true,
            DCConfirmationFlag: "S",
            message: `Are you sure you want to Mark the Patient Visit to "Show" ?`,
            cardDetails: ele,
          });
        } else if (DCConfirmationFlag === "N") {
          setIsConfirmationPopup({
            isOpen: true,
            DCConfirmationFlag: "N",
            message: `Are you sure you want to Mark the Patient Visit to "No Show" ?`,
            cardDetails: ele,
          });
        } else if (DCConfirmationFlag === "U") {
          setIsUploadReportPopup({
            isOpen: true,
            cardDetails: ele,
            isUploadReport: true,
          });
        }
      } else {
        getSnackbarSuccess("info", res?.data?.message, dispatch);
        await dispatch(
          getWhatsappAppointmentActions(
            {
              page: globalReducer?.getCurrentPage,
              rows: 10,
            },
            params
          )
        );
      }
    });
  };
  return (
    <div className="__appointment_card-container">
      <div className="whatsapp_filter_container">
        <img
          src={AppoinmentReducer?.getProviderDetails?.providerLogo}
          style={{ width: "50px", height: "50px" }}
        />
        <h1 className="heading2">
          {AppoinmentReducer?.getProviderDetails?.providerName}
        </h1>
      </div>
      <div className="results mt-4" style={{ marginLeft: "20px" }}>
        Total <span>{globalReducer?.getTotalCount}</span> results
      </div>
      {AppoinmentReducer?.getWhatsappAppointmentDetails?.map((ele, index) => {
        return (
          <div
            className={`appoinment-detail ${
              ele?.status === "Pending"
                ? "pending-appoint"
                : ele?.status === "Approved" ||
                  ele?.status === "Completed" ||
                  ele?.status === "Report Pending" ||
                  ele?.status === "Report On Hold" ||
                  ele?.status === "Confirmed"
                ? "approve-appoint"
                : ele?.status === "Expired"
                ? "expire-appoint"
                : (ele?.status === "Rejected" ||
                    ele?.status === "No Show" ||
                    ele?.status === "Cancelled") &&
                  "reject-appoint"
            }`}
            key={index}
          >
            <div
              className="topsec"
              style={{
                backgroundColor: styleTopSecBackgroundColor(ele?.status),
                color: styleTopSecColor(ele?.status),
                border: styleTopSecBackgroundColor(ele?.status),
              }}
            >
              <div className="row">
                <div className="col-lg-6 col-6">
                  <div className="select_single">
                    <h2>
                      {ele?.valueType === "PRODUCT"
                        ? "Case ID"
                        : "Policy Number"}
                      - {ele?.caseNo}
                      {ele?.policyRefNo}
                    </h2>
                  </div>
                </div>
                <div className="col-lg-6 col-6 ">
                  <h2 className="float-end" style={{ marginRight: "10px" }}>
                    Status -
                    {ele?.status === "Approved" ? "Accepted" : ele?.status}
                  </h2>
                </div>
              </div>
            </div>
            <div className="bottomsec">
              <div className="row">
                <div className="col-lg-4">
                  <h2 style={{ color: styleCustomerColor(ele?.status) }}>
                    {ele?.proposerName} {ele?.gender}
                  </h2>
                  <p>
                    <i className="fas fa-mail-bulk"></i>&nbsp;&nbsp;
                    {ele?.email}
                  </p>
                  <p>
                    <i className="fa fa-phone"></i> &nbsp;&nbsp;
                    {ele?.mobileno}
                  </p>
                  <p className="bottomtxt" style={{ fontWeight: "700" }}>
                    <i className="fa-regular fa-calendar-days icon"></i>
                    &nbsp;&nbsp;
                    {moment(ele?.appointmentDateTime).format("Do MMMM YYYY")}-
                    &nbsp;
                    {moment(ele?.appointmentDateTime).format("hh:mm A")}
                  </p>
                  {ele?.modeOfPayment === "Prepaid" ? (
                    <p
                      className="bottomtxt"
                      style={{ fontWeight: "700", color: "#5157a0" }}
                    >
                      <img src="./images/paymenticontick.png" width={16} />
                      &nbsp;&nbsp;
                      {ele?.modeOfPayment}
                    </p>
                  ) : (
                    <p
                      className="bottomtxt"
                      style={{ fontWeight: "700", color: "#5157a0" }}
                    >
                      <i className="fas fa-wallet icon"></i> &nbsp;&nbsp;
                      {ele?.modeOfPayment}
                    </p>
                  )}
                </div>
                <div className="col-lg-4">
                  <p>
                    <span>Visit Type: </span> {ele?.visit}
                  </p>
                  <p>
                    <span> Client Name: </span> {ele?.clientName}
                  </p>
                  {ele?.visit !== "Centre Visit" && (
                    <p style={{ minHeight: "60px" }}>
                      <span> Customer Address: </span>
                      {ele?.address === ""
                        ? " N/A"
                        : isShowMoreAddress && cardIndex === index
                        ? ele?.address
                        : ele?.address?.split(" ")?.slice(0, 20)?.join(" ")}
                      <span
                        onClick={() => {
                          setCardIndex(index);
                          setIsShowMoreAddress(
                            isShowMoreAddress && cardIndex === index
                              ? false
                              : true
                          );
                          setIsShowMore(false);
                        }}
                        style={{ color: "#5157a0", cursor: "pointer" }}
                      >
                        {ele?.address.split(" ").length < 20 ? (
                          ""
                        ) : isShowMoreAddress && cardIndex === index ? (
                          <span style={{ color: "#5157a0", cursor: "pointer" }}>
                            &nbsp;&nbsp;view less
                          </span>
                        ) : (
                          "...view more"
                        )}
                      </span>
                    </p>
                  )}
                </div>
                <div className="col-lg-4">
                  {ele?.specialityName === null ? (
                    <p>
                      <span> Package Name: </span> {ele?.packageName}
                    </p>
                  ) : (
                    <p>
                      <span> Doctor Name: </span> {ele?.doctorName}
                    </p>
                  )}
                  {ele?.specialityName === null ? (
                    <p style={{ minHeight: "60px" }}>
                      <span> Test Details: </span>
                      {isShowMore && cardIndex === index
                        ? ele?.tests
                        : ele?.tests?.split(" ")?.slice(0, 20)?.join(" ")}
                      <span
                        onClick={() => {
                          setCardIndex(index);
                          setIsShowMore(
                            isShowMore && cardIndex === index ? false : true
                          );
                          setIsShowMoreAddress(false);
                        }}
                        style={{ color: "#5157a0", cursor: "pointer" }}
                      >
                        {ele?.tests?.split(" ").length < 20 ? (
                          ""
                        ) : isShowMore && cardIndex === index ? (
                          <span style={{ color: "#5157a0", cursor: "pointer" }}>
                            &nbsp;&nbsp;view less
                          </span>
                        ) : (
                          "...view more"
                        )}
                      </span>
                    </p>
                  ) : (
                    <p>
                      <span> Speciality Name: </span> {ele?.specialityName}
                    </p>
                  )}
                  <div className="div-accept-reject">
                    {(ele?.status === "Confirmed" ||
                      ele?.status === "Approved") &&
                    moment(ele?.appointmentDateTime).format("x") <=
                      moment().format("x") ? (
                      <>
                        <button
                          className="accept-btn"
                          type="button"
                          onClick={() => checkStatusUpdateHandler(ele, "S")}
                        >
                          Show
                        </button>
                        <button
                          className="reject-btn-indivitual"
                          type="button"
                          onClick={() => checkStatusUpdateHandler(ele, "N")}
                        >
                          No Show
                        </button>
                      </>
                    ) : ele?.status === "Report Pending" ||
                      ele?.status === "Report On Hold" ? (
                      <button
                        className="accept-btn"
                        type="button"
                        onClick={async () => {
                          checkStatusUpdateHandler(ele, "U");
                        }}
                      >
                        Upload Report
                      </button>
                    ) : ele?.status === "Completed" ? (
                      <button
                        className="accept-btn"
                        type="button"
                        onClick={async () => {
                          //   getDispatch(IS_SHOW_POPUP, true, dispatch);
                          setIsUploadReportPopup({
                            isOpen: true,
                            cardDetails: ele,
                            isUploadReport: false,
                          });
                        }}
                      >
                        View Report
                      </button>
                    ) : null}
                  </div>
                </div>
              </div>
            </div>
          </div>
        );
      })}
      <div className="mt-2" style={{ paddingBottom: "20px" }}>
        {globalReducer?.getTotalCount !== 0 && (
          <PaginatedItems
            totalCount={globalReducer?.getTotalCount}
            perPageData="10"
          />
        )}
      </div>
      <Modal
        isOpen={isConfirmationPopup?.isOpen}
        className="modal-confirmation-popup modal-noshow-popup"
        overlayClassName="overlay-confirmation-popup network-z-index"
        ariaHideApp={false}
      >
        <WhatsappConfirmationPopup
          isConfirmationPopup={isConfirmationPopup}
          setIsConfirmationPopup={setIsConfirmationPopup}
          params={params}
        />
      </Modal>
      <Modal
        isOpen={isUploadReportPopup?.isOpen}
        className="modal-upload-popup"
        overlayClassName="overlay-upload-popup network-z-index"
        ariaHideApp={false}
      >
        <WhatsappUploadReportPopup
          isUploadReportPopup={isUploadReportPopup}
          setIsUploadReportPopup={setIsUploadReportPopup}
          params={params}
        />
      </Modal>
    </div>
  );
};

export default WhatsappAppointmentActions;
